module.exports = __webpack_public_path__ + "img/a0309_7.4e29d81d.png";